import { CollapseTitle } from './CollapseTitle'
import { CollapseContainer } from './CollpaseContainer'

export const FaqCollapse = {
  root: CollapseContainer,
  title: CollapseTitle
}
